// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1XBFw","header":"Messages_header__2b0nq"};